// src/components/Admin/Finance/TableExpenses.js
import React from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import { formatoFecha } from '../../../utils/date';
import { Edit, Delete, ContentCopy } from "@mui/icons-material";
//import { formatoFecha } from "./././utils/date";

/**
 * TableExpenses (server-side pagination ready)
 *
 * Props:
 * - expenses: array (results del backend)
 * - count: number (total del backend)
 * - page: number (0-based, MUI)
 * - rowsPerPage: number
 * - onPageChange: (newPage:number) => void
 * - onRowsPerPageChange: (newRows:number) => void
 *
 * - editExpense(row)
 * - onDeleteExpense(row)
 * - onDuplicateExpense(row)   ✅ nuevo
 */
export function TableExpenses({
  expenses = [],
  editExpense,
  onDeleteExpense,
  onDuplicateExpense,

  // server-side pagination (opcionales para no romper llamadas antiguas)
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) {
  const isServerPaging =
    typeof count === "number" &&
    typeof page === "number" &&
    typeof rowsPerPage === "number" &&
    typeof onPageChange === "function" &&
    typeof onRowsPerPageChange === "function";

  const handleChangePage = (_, newPage) => {
    if (isServerPaging) onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    if (!isServerPaging) return;
    const next = parseInt(e.target.value, 10);
    onRowsPerPageChange(next);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Monto</TableCell>
              <TableCell>Proveedor</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {expenses.map((row, idx) => {
              const rowNumber = isServerPaging
                ? page * rowsPerPage + idx + 1
                : idx + 1;

              return (
                <TableRow key={row.id ?? `${idx}-${rowNumber}`}>
                  <TableCell>{rowNumber}</TableCell>
                  <TableCell>{row?.date ? formatoFecha(row.date) : "—"}</TableCell>
                  <TableCell>{row?.notes || "—"}</TableCell>
                  <TableCell>{row?.amount ?? "—"}</TableCell>
                  <TableCell>{row?.supplier?.name || row?.supplier_name || "—"}</TableCell>

                  <TableCell align="right">
                    <Button onClick={() => editExpense?.(row)} title="Editar">
                      <Edit />
                    </Button>

                    <Button
                      onClick={() => onDuplicateExpense?.(row)}
                      title="Duplicar"
                      disabled={!onDuplicateExpense}
                    >
                      <ContentCopy />
                    </Button>

                    <Button onClick={() => onDeleteExpense?.(row)} title="Eliminar">
                      <Delete />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación: si viene server-side usamos count real, sino fallback */}
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={isServerPaging ? count : expenses.length}
        rowsPerPage={isServerPaging ? rowsPerPage : 20}
        page={isServerPaging ? page : 0}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}
